import type { StorageDriver, StorageKey } from "@exonn/storage";
import { localStorageDriver } from "src/storage/localeStorage.driver.ts";
import { reaction } from "mobx";
import { set, get } from "lodash";

export const persistStore = <
  Store extends Record<string, any> = Record<string, any>,
>(
  store: Store,
  key: StorageKey,
  properties: (keyof Store)[],
  driver: StorageDriver = localStorageDriver,
) => {
  type PersistedState = Partial<Record<keyof Store, any>>;
  const persistedState = driver.get<PersistedState>(key);
  if (persistedState) {
    properties.forEach((key) => {
      if (get(persistedState, key)) {
        set(store, key, persistedState[key]);
      }
    });
  }

  const startPersisting = () => {
    return reaction(
      () => {
        return properties.reduce((acc, property) => {
          return {
            ...acc,
            [property]: get(store, property),
          };
        }, {} as PersistedState);
      },
      (values) => {
        driver.set<PersistedState>(key, values);
      },
    );
  };

  return {
    startPersisting,
  };
};
